import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1159acff&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1159acff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mac/Documents/project/code/shop/zhongyijia-admin-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1159acff')) {
      api.createRecord('1159acff', component.options)
    } else {
      api.reload('1159acff', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1159acff&scoped=true", function () {
      api.rerender('1159acff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/administratorAuthority/adminList/index.vue"
export default component.exports